const t = {
  name: "Bottle",
  dimensions: { width: 18, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 18 40" style="enable-background:new 0 0 18 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,0v6.1c2.3,0.5,4,2.5,4,4.9v24c0,2.8-2.2,5-5,5h-0.2l-0.2-0.1c-2.2-1.1-4.9-1.1-7.1,0L5.2,40H5
			c-2.8,0-5-2.2-5-5V11c0-2.4,1.7-4.4,4-4.9V0H14z M13,8H5c-1.7,0-3,1.3-3,3v5h14v-5C16,9.3,14.7,8,13,8z M2,28h14V18H2V28z M2,30v5
			c0,1.6,1.2,2.9,2.8,3c2.7-1.3,5.8-1.3,8.4,0c1.6-0.1,2.8-1.4,2.8-3v-5H2z M12,6V2H6v4H12z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as Bottle
};
